"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useGoToDetailedUsersReport = void 0;
const store_1 = require("@app/store");
const moment_1 = __importDefault(require("moment"));
const react_1 = __importDefault(require("react"));
const is_defined_1 = require("../is-defined");
const routeUtil_1 = __importDefault(require("../routeUtil"));
const useRememberTableConfig_1 = require("./useRememberTableConfig");
const EMPLOYEE_REPORT_TABLE = 'employeeReportTable';
const useGoToDetailedUsersReport = (selectedMonth) => {
    const rememberTableConfig = (0, useRememberTableConfig_1.useRememberTableConfig)(EMPLOYEE_REPORT_TABLE);
    const employees = (0, store_1.useRootSelector)((state) => Object.entries(state.employees));
    const goToDetailedReport = react_1.default.useCallback((userIds) => {
        const currentEmployees = employees
            .filter((emp) => userIds.some((id) => emp[0] === id))
            .map((emp) => (0, is_defined_1.isValue)(emp[1].employeeId)
            ? `${emp[1].name ?? ''} (${emp[1].employeeId})`
            : emp[1].name)
            .filter(is_defined_1.isValue);
        const month = (0, moment_1.default)(selectedMonth, 'YYYY-MM');
        rememberTableConfig([
            ['filters', [{ id: 'employee', value: currentEmployees ?? [] }]],
            [
                'period',
                {
                    start: month.startOf('month').toDate(),
                    end: month.endOf('month').toDate(),
                },
            ],
        ]);
        routeUtil_1.default.navigate('/backoffice/reports/emp');
    }, [rememberTableConfig, selectedMonth, employees]);
    return goToDetailedReport;
};
exports.useGoToDetailedUsersReport = useGoToDetailedUsersReport;
